import type { LoginTranslations } from "../interfaces/login";

export const loginTranslations: LoginTranslations = {
  title: "Mova seu dinheiro",
  title_emphasis: "em segundos.",
  subtitle:
    "Coloca é a tecnologia que permite {emphasis} na América Latina. Envie e receba como local, sem os altos custos e prazos do SWIFT.",
  subtitle_emphasis: "enviar e receber dinheiro",
  google_button: "Entre com o Google",
  login_button: "Entrar",
  input_user_label: "E-mail",
  input_user_placeholder: "Digite seu e-mail",
  input_password_label: "Senha",
  input_password_placeholder: "Digite sua senha",
  checkbox_remember_me: "Lembrar-me",
  login_account_label_prefix: "Já tem uma conta?",
  login_account_label_button: "Entrar",
  terms_and_conditions: "Termos e condições",
  // 2FA translations
  twofa_title: "Verificação em duas etapas",
  twofa_subtitle: "Digite o código de 6 dígitos do seu aplicativo autenticador",
  twofa_authenticator_hint: "Abra seu aplicativo autenticador (Google Authenticator, Authy, etc.)",
  twofa_digits_counter: "{count}/6 dígitos digitados",
  twofa_verify_button: "Verificar código",
  twofa_verifying_button: "Verificando...",
  twofa_back_link: "Voltar ao login",
  twofa_support_text: "Não tem acesso ao seu aplicativo autenticador?",
  twofa_support_link: "Contatar suporte",
  // Change Password translations
  change_password_title: "Alterar Senha",
  change_password_subtitle: "Por favor, insira sua senha atual e uma nova senha.",
  current_password_label: "Senha Atual",
  current_password_placeholder: "Insira a senha atual",
  new_password_label: "Nova Senha",
  new_password_placeholder: "Insira a nova senha",
  confirm_password_label: "Confirmar Nova Senha",
  confirm_password_placeholder: "Confirme a nova senha",
  change_password_button: "Alterar Senha",
  back_button: "Voltar",
  input_error_same_password: "A nova senha não pode ser igual à atual",
  input_error_passwords_must_match: "As senhas devem coincidir",
  // Forgot password flow
  forgot_password_link: "Esqueceu sua senha?",
  fp_step_request: "Solicitar",
  fp_step_verify: "Verificar",
  fp_step_new: "Nova senha",
  fp_step_done: "Pronto",
  fp_request_title: "Recupere sua senha",
  fp_request_subtitle: "Digite o e-mail da sua conta e enviaremos um link seguro para criar uma nova senha.",
  fp_request_email_label: "E-mail",
  fp_request_email_placeholder: "voce@empresa.com",
  fp_request_hint: "Enviaremos um link válido por 1 hora.",
  fp_request_submit: "Enviar link de recuperação",
  fp_request_back: "Voltar ao login",
  fp_verify_title: "Verifique seu e-mail",
  fp_verify_subtitle:
    "Enviamos um link de recuperação para {email}. Clique no botão do e-mail ou digite o código abaixo.",
  fp_verify_code_label: "Código de verificação",
  fp_verify_code_hint: "O código tem 6 dígitos e expira em 1 hora.",
  fp_verify_submit: "Verificar código",
  fp_verify_resend: "Não recebeu?",
  fp_verify_resend_cooldown: "Reenviar em {seconds}s",
  fp_verify_change_email: "Alterar e-mail",
  fp_new_title: "Crie uma nova senha",
  fp_new_subtitle: "Verificado para {email}. Escolha uma senha que você não tenha usado antes.",
  fp_new_password_label: "Nova senha",
  fp_new_password_placeholder: "Mínimo de 8 caracteres",
  fp_new_confirm_label: "Confirme a senha",
  fp_new_confirm_placeholder: "Repita a senha",
  fp_new_submit: "Redefinir senha",
  fp_new_strength: "Força",
  fp_new_strength_empty: "Muito fraca",
  fp_new_strength_weak: "Fraca",
  fp_new_strength_fair: "Razoável",
  fp_new_strength_good: "Boa",
  fp_new_strength_strong: "Forte",
  fp_new_req_length: "Pelo menos 8 caracteres",
  fp_new_req_number: "Um número",
  fp_new_req_symbol: "Um símbolo especial (!@#$...)",
  fp_new_req_long: "12 caracteres ou mais (recomendado)",
  fp_new_match_ok: "Coincidem",
  fp_new_match_error: "As senhas não coincidem.",
  fp_done_title: "Senha atualizada",
  fp_done_subtitle: "Sua senha foi alterada com sucesso. Você já pode entrar com suas novas credenciais.",
  fp_done_go_login: "Ir para entrar",
  fp_error_invalid_code: "Código inválido ou expirado.",
  fp_error_expired: "O link expirou. Solicite um novo.",
  fp_error_weak_password: "A senha não atende aos requisitos mínimos.",
  fp_error_network: "Não foi possível completar a solicitação. Verifique sua conexão e tente novamente.",

  // Accept invitation
  inv_verifying_aria: "Verificando o convite",
  inv_eyebrow: "Convite",
  inv_title: "Você foi convidado a entrar em {org}",
  inv_email_label: "Convite para",
  inv_name_label: "Nome completo",
  inv_name_placeholder: "Nome e sobrenome",
  inv_name_required: "Insira seu nome completo para aceitar o convite.",
  inv_name_max: "Máximo de 255 caracteres.",
  inv_password_label: "Crie uma senha",
  inv_password_placeholder: "••••••••",
  inv_password_max: "Máximo de 128 caracteres.",
  inv_confirm_label: "Confirme sua senha",
  inv_confirm_placeholder: "••••••••",
  inv_submit: "Entrar em {org}",
  inv_expiry_note: "Este link é de uso único e vence em {date}.",
  inv_footer_ignore: "Conta errada ou convite inesperado? Você pode ignorar este e-mail.",
  inv_session_notice: "Você está conectado como {current}. Este convite é para {invited}.",
  inv_session_continue: "Continuar e trocar de conta",
  inv_throttled: "Muitas tentativas — aguarde um minuto e tente novamente.",
  inv_invalid_title: "Este link de convite não é mais válido",
  inv_invalid_body:
    "Ele pode ter vencido ou já ter sido utilizado. Peça a quem convidou você que envie um novo convite.",
  inv_go_login: "Ir para entrar",
  inv_error_title: "Não foi possível verificar o convite",
  inv_error_body: "Houve um problema de conexão ao validar o link. Tente novamente em instantes.",
  inv_retry: "Tentar novamente",
  inv_conflict_title: "Já existe uma conta com este e-mail",
  inv_conflict_body: "O convite para {email} pertence a uma conta já registrada na Coloca.",
  inv_conflict_login: "Entrar",
  inv_success_title: "Bem-vindo a {org}",
  inv_success_entering: "Entrando no seu painel…",
};
